import React, {useContext} from 'react';
import { FunctionContext } from '../../contexts/function.context';
import Button, { BUTTON_TYPE_CLASSES } from '../Button/Button.component';


const UploadButton = (props) => {

    const { currentFunctionCode, setFunctionCode } = useContext(FunctionContext);

    React.useEffect(() => {
        if (currentFunctionCode === null){
            setFunctionCode({
                code: '',
                path: '',
                name: '',
                type: '',
                url: '',
            });
        }
    }

    );

    const onClickUploadButton = (functionItem) => {
        if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log('Function Before = ', JSON.stringify(currentFunctionCode));
            console.log('Function Name = ', functionItem.name);
            console.log('Function Code = ', functionItem.code);
            console.log('Function Path = ', functionItem.path);
            console.log('Function Tyype = ', functionItem.type);
            console.log('Function URL = ', functionItem.url);
        }

        setFunctionCode(functionItem);
        if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
        console.log('Function After = ', JSON.stringify(functionItem));}
    
    };
    
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
        console.log('rendering UploadButton');
        console.log(props.buttonText);
    }

    return (
        currentFunctionCode ? (
        props.buttonItem.code === currentFunctionCode.code ? (
            <div>
                <Button buttonType={BUTTON_TYPE_CLASSES.base} onClick={() => onClickUploadButton(props.buttonItem)}>{props.buttonText}</Button>
            </div>
        
    
        ) : (
                <div>
                    <Button buttonType={BUTTON_TYPE_CLASSES.function} onClick={() => onClickUploadButton(props.buttonItem)}>{props.buttonText}</Button>
                </div>
        )) : (null)

    )

}

export default UploadButton;